<script setup lang="ts">
interface Props {
  iconPath: string;
  partnerBgColor: string;
  isCompleted?: boolean;
  size?: 'xs' | 'sm' | 'md';
}

withDefaults(defineProps<Props>(), {
  isCompleted: false,
  size: 'sm',
});
</script>

<template>
  <KUIUnifiedActivityBadge
    :icon-url="iconPath"
    :completed="isCompleted"
    :size="size"
    :partner-bg-color="partnerBgColor"
  />
</template>
